import React from 'react';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import { useLayout } from '@app/providers/LayoutContext';
import 'react-loading-skeleton/dist/skeleton.css';

/**
 * Componente Skeleton que se adapta automáticamente al tema actual
 * Se usa igual que el Skeleton normal pero con colores apropiados al tema
 */
export const DarphaSkeleton = (props) => {
  const { isDarkTheme } = useLayout();
  
  // Colores adaptados al tema actual
  const baseColor = isDarkTheme ? 'var(--gray-700)' : 'var(--gray-200)';
  const highlightColor = isDarkTheme ? 'var(--gray-600)' : 'var(--gray-100)';
  
  return (
    <SkeletonTheme baseColor={baseColor} highlightColor={highlightColor}>
      <Skeleton {...props} />
    </SkeletonTheme>
  );
};

/**
 * Proveedor global para usar en App.jsx si se quiere que todos los Skeleton de la app
 * tengan los colores del tema sin modificar cada archivo
 */
export const GlobalSkeletonProvider = ({ children }) => {
  const { isDarkTheme } = useLayout();
  
  // Colores adaptados al tema actual
  const baseColor = isDarkTheme ? 'var(--gray-700)' : 'var(--gray-200)';
  const highlightColor = isDarkTheme ? 'var(--gray-600)' : 'var(--gray-100)';
  
  return (
    <SkeletonTheme baseColor={baseColor} highlightColor={highlightColor}>
      {children}
    </SkeletonTheme>
  );
};

export default DarphaSkeleton;